import { isIosApp, isNativeAppWebView } from "./utils";

/**
 * Scroll the main document to the top. Uses instant scroll in native app
 * WebViews where smooth scrolling is unreliable and async layout can leave
 * the viewport near the footer after route changes.
 */
export function scrollPageToTop(options = {}) {
  if (typeof window === "undefined") {
    return;
  }

  const useInstant =
    options.instant ?? (isIosApp() || isNativeAppWebView());

  const runScroll = () => {
    if (useInstant) {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  runScroll();

  requestAnimationFrame(() => {
    runScroll();
    if (useInstant) {
      window.setTimeout(runScroll, 50);
    }
  });
}
